import React from "react";
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Line,
  XAxis,
  YAxis,
} from "recharts";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";

const LINE_COLOR = "#1F6B4F";
const CARD_BG = "#F6F7F9";

// chart.jsx 无完整 TS 类型，这里做宽松断言
const ChartBox = ChartContainer as React.ComponentType<any>;
const TooltipBody = ChartTooltipContent as React.ComponentType<any>;

const formatAxisDate = (value: any) => {
  if (!value) return "";
  const s = String(value);
  if (s.length >= 10 && s.includes("-")) return s.slice(5, 10);
  if (s.length === 8) return `${s.slice(4, 6)}-${s.slice(6, 8)}`;
  return s.slice(-5);
};

type RecreateStatsChartProps = {
  data?: any[];
};

const RecreateStatsChart = ({ data }: RecreateStatsChartProps) => {
  const chartConfig = {
    reCreateCount: {
      label: "reCreate",
      color: LINE_COLOR,
    },
  };

  return (
    <div
      className="w-full max-w-[520px] min-w-0 overflow-hidden rounded-xl border border-slate-200"
      style={{ backgroundColor: CARD_BG }}
    >
      <div className="flex items-center justify-between px-3 pb-3 pt-3">
        <h3 className="text-base font-semibold tracking-tight text-slate-900">
          recreate count
        </h3>
      </div>
      <div className="px-1 pb-1">
        <div className="rounded-xl border border-slate-200 bg-white px-2 pb-2 pt-3">
          <ChartBox config={chartConfig} className="aspect-[16/9] w-full">
            <ComposedChart
              accessibilityLayer
              data={data || []}
              margin={{ top: 8, right: 12, left: 0, bottom: 0 }}
            >
              <defs>
                <linearGradient id="recreateFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={LINE_COLOR} stopOpacity={0.18} />
                  <stop offset="100%" stopColor={LINE_COLOR} stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid
                vertical={false}
                strokeDasharray="3 3"
                stroke="#E5E7EB"
              />
              <XAxis
                dataKey="date"
                tickLine={false}
                axisLine={false}
                tickMargin={10}
                tick={{ fill: "#9CA3AF", fontSize: 12 }}
                tickFormatter={formatAxisDate}
              />
              <YAxis
                tickLine={false}
                axisLine={false}
                width={40}
                tickMargin={8}
                tick={{ fill: "#9CA3AF", fontSize: 12 }}
                tickFormatter={(v) =>
                  Number(v) >= 1000 ? `${Math.round(Number(v) / 1000)}k` : v
                }
              />
              <ChartTooltip
                cursor={{ stroke: "#D1D5DB", strokeDasharray: "4 4" }}
                content={
                  <TooltipBody
                    indicator="line"
                    labelFormatter={(label: any) => formatAxisDate(label)}
                  />
                }
              />
              <Area
                type="monotone"
                dataKey="reCreateCount"
                stroke="none"
                fill="url(#recreateFill)"
                isAnimationActive={false}
              />
              <Line
                type="monotone"
                dataKey="reCreateCount"
                stroke={LINE_COLOR}
                strokeWidth={2}
                dot={false}
                activeDot={{
                  r: 5,
                  fill: "#fff",
                  stroke: LINE_COLOR,
                  strokeWidth: 2,
                }}
              />
            </ComposedChart>
          </ChartBox>
        </div>
      </div>
    </div>
  );
};

export default RecreateStatsChart;
